import { action, makeObservable, observable } from 'mobx';
import {
  userInfoStore,
  notificationStore,
  freeBetStore,
  applicationStore,
} from '@pascal/pascal-core';
import { betStore, gameConfigStore, roundInfoStore } from '@pascal/pascal-core/shared/core/store';
// eslint-disable-next-line import/no-extraneous-dependencies
import uuid from 'react-uuid';
import { gameLiveConnection } from '../services';
import { checkDoBetModel } from '../helpers/supporters';

class DoBetStore {
  winAmount = 0;

  isLoadingBetButton = false;

  isLoadingReBetButton = false;

  demoBetOdd = null;

  totalBetsAmount = 0;

  betData = {
    betId: null,
    amount: gameConfigStore.limits.minBet || 0,
    isBetAccepted: false,
    winAmount: null,
    isDisabled: false,
  };

  reBetData = [];

  constructor() {
    makeObservable(this, {
      winAmount: observable,
      demoBetOdd: observable,
      betData: observable.deep,
      reBetData: observable.deep,
      totalBetsAmount: observable,
      isLoadingBetButton: observable,
      isLoadingReBetButton: observable,
      doBetSender: action.bound,
      updatedReBetData: action.bound,
      setReBetData: action.bound,
      setWinAmount: action.bound,
      setBetAmount: action.bound,
      resetGameStates: action.bound,
      updateBetAccepted: action.bound,
      handleDoBetResult: action.bound,
      decreaseDemoBalance: action.bound,
      increaseDemoBalance: action.bound,
      updateInitialBetData: action.bound,
      setIsLoadingBetButton: action.bound,
      setIsLoadingReBetButton: action.bound,
      updateTotalBetsAmount: action.bound,
      updateIsDisabledBetSection: action.bound,
      detectAndSetReBetData: action.bound,
    });
  }

  updatedReBetData(betData) {
    this.reBetData = [...this.reBetData, betData];
  }

  setReBetData(bets) {
    this.reBetData = bets;
  }

  detectAndSetReBetData(data, isFromFreeBetToggle) {
    if (data.length) {
      const { activeFreeBet } = freeBetStore;
      const bets = data.filter((bet) => {
        if (!activeFreeBet?.id && bet.freeBetId) {
          return false;
        }

        if (activeFreeBet?.id && !bet.freeBetId) {
          return false;
        }

        if (activeFreeBet?.id && bet.freeBetId === activeFreeBet.id) {
          return true;
        }

        return true;
      });

      if (isFromFreeBetToggle) {
        this.setReBetData(bets);
      } else {
        const betsForParse = bets.map((bet) => {
          if (bet.additionalParams.markets.length && this.reBetData.length) {
            this.setReBetData([]);
          }

          return bet;
        });

        betsForParse.forEach((betForParse) => {
          if (betForParse && betForParse.additionalParams.markets.length) {
            betForParse.additionalParams.markets.forEach((item) => {
              this.updatedReBetData({
                ...item,
                userId: betForParse.userId,
                freeBetId: betForParse.freeBetId,
                currencyCode: betForParse.currencyCode,
                playerExternalId: betForParse.playerExternalId,
              });
            });
          }
        });
      }
    }
  }

  updateTotalBetsAmount(amount, isReset = false) {
    if (isReset) {
      this.totalBetsAmount = 0;
    } else {
      this.totalBetsAmount += Number(amount);
    }
  }

  updateBetAccepted(isBetAccepted, betId) {
    this.betData = {
      ...this.betData,
      isBetAccepted,
      betId,
    };
  }

  setIsLoadingBetButton(isLoadingBetButton) {
    this.isLoadingBetButton = isLoadingBetButton;
  }

  setIsLoadingReBetButton(isLoadingReBetButton) {
    this.isLoadingReBetButton = isLoadingReBetButton;
  }

  setBetAmount(amount) {
    this.betData = { ...this.betData, amount };
  }

  updateIsDisabledBetSection(isDisabledBetSection) {
    this.betData = {
      ...this.betData,
      isDisabled: isDisabledBetSection,
    };
  }

  setWinAmount(winAmount) {
    this.winAmount = winAmount;
    if (winAmount) {
      setTimeout(() => gameLiveConnection.getBalance(), 900);
    }
  }

  increaseDemoBalance(amount, odd) {
    const balance = userInfoStore.balance + amount * odd;
    userInfoStore.setDemoBalance(balance);
  }

  decreaseDemoBalance(betAmount) {
    userInfoStore.setDemoBalance(userInfoStore.balance - betAmount);
  }

  resetGameStates() {
    this.betData = {
      betId: null,
      amount: gameConfigStore.limits.minBet || 0,
      isBetAccepted: false,
      winAmount: null,
      finishedOdd: null,
      isDisabled: false,
    };
    this.isLoadingBetButton = false;
    this.setWinAmount('');
    this.updateTotalBetsAmount(0, true);
    notificationStore.setNotificationType(null);
  }

  updateInitialBetData(data) {
    this.betData = data;
  }

  doBetSender(color) {
    const { limits } = gameConfigStore;
    const { balance: userBalance } = userInfoStore;
    const { activeFreeBet } = freeBetStore;
    const { roundId } = roundInfoStore;
    const { isDemo } = applicationStore;
    const { id: freeBetId, amount: freeBetAmount } = activeFreeBet;
    const { amount } = this.betData;

    const betModel = {
      amount,
      roundId,
      betData: {
        markets: [
          {
            id: uuid(),
            market: color,
            amount: amount,
          },
        ],
      },
    };

    if (freeBetId && !isDemo) {
      betModel.freeBetId = freeBetId;
      betModel.amount = freeBetAmount;
    }

    const responseCode = checkDoBetModel(limits, userBalance, betModel.amount);

    this.setIsLoadingBetButton(true);
    if (responseCode) {
      notificationStore.setNotificationType({
        responseCode,
      });

      // if (isDemo) {
      //   this.setIsLoadingBetButton(false);
      // }
      this.updateIsDisabledBetSection(false);
    }
    // else if (isDemo) {
    //   const currentDemoBetData = {
    //     ...betData,
    //     status: BetStatus.Pending,
    //     id: createGuid(),
    //     odd: this.demoBetOdd,
    //     date: new Date(),
    //     responseCode: BetResponseCode.Success,
    //   };
    //   if (currentDemoBetData.amount <= userInfoStore.balance) {
    //     soundService.playBetAccepted();
    //     this.decreaseDemoBalance(betData.amount);
    //     this.updateTotalBetsAmount(betData.amount);
    //     this.handleDoBetResult(currentDemoBetData);
    //     popupStore.updateDemoBetsCount();
    //   }
    // } else {
    gameLiveConnection.doBet(betModel);
    // }
  }

  handleDoBetResult(doBetData) {
    const { responseCode } = doBetData;
    const isReBet = doBetData.betData.markets.some((item) => item.isReBet);
    if (!isReBet && this.reBetData.length) {
      const { liveBets } = betStore;
      const hasBets = liveBets.some((item) => item.userId === userInfoStore.userId);

      if (!hasBets) {
        this.setReBetData([]);
      }
    }

    this.setIsLoadingBetButton(false);
    this.setIsLoadingReBetButton(false);
    notificationStore.setNotificationType({ responseCode });
  }

  handleReBetClick = () => {
    const { roundId } = roundInfoStore;
    const { gameTypeId } = gameConfigStore;
    const { activeFreeBet } = freeBetStore;
    const { isDemo } = applicationStore;
    this.setIsLoadingReBetButton(true);
    const reBetModel = {
      roundId,
      gameTypeId,
      amount: this.reBetData.reduce((acc, curr) => acc + curr.amount, 0),
      freeBetId: activeFreeBet?.id && !isDemo ? activeFreeBet?.id : null,
      betData: {
        markets: this.reBetData.map((el) => {
          return {
            isReBet: true,
            amount: el.amount,
            market: el.market,
            id: uuid(),
            // freeBetId: activeFreeBet?.id && !isDemo ? activeFreeBet?.id : null,
          };
        }),
      },
    };
    gameLiveConnection.doBet(reBetModel);
  };
}

export const doBetStore = new DoBetStore();
